import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { HomeComponent } from './home/home.component';
import { ResumeComponent } from './resume/resume.component';
import { PublicationsComponent } from './publications/publications.component';
import { DimensionalanalysisComponent } from './dimensionalanalysis/dimensionalanalysis.component';
import { GascalcComponent } from './gascalc/gascalc.component';
import { PropulsionComponent } from './propulsion/propulsion.component';
import { AerocalcComponent } from './aerocalc/aerocalc.component';
import { ThermoComponent } from './thermo/thermo.component';
import { RpecalcComponent } from './rpecalc/rpecalc.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'resume', component: ResumeComponent },
  { path: 'publications', component: PublicationsComponent },
  { path: 'dimensionalanalysis', component: DimensionalanalysisComponent },
  { path: 'gascalculator', component: GascalcComponent },
  { path: 'propulsion', component: PropulsionComponent },
  { path: 'aerocalculator', component: AerocalcComponent },
  { path: 'thermodynamics', component: ThermoComponent },
  { path: 'rpecalculator', component: RpecalcComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
